<div class="text-formatting-modal">
  <div class="text-formatting-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>{{ isDefaultFormatType ? 'Default format' : 'Format' }}</h1>
      <div sub-heading class="sub-header"><span class="sub-header-field">Field:</span>{{ title }}</div>
    </mode-dialog-header>
  </div>
  <div class="content-pane">
    <div *ngIf="isDefaultFormatType" class="default-format-info">
      Set default formatting for <span class="description-hightlight">all charts</span> using this field; chart-level
      formatting overrides these defaults.
    </div>
    <mode-labeled-menu
      data-test="field-type-menu"
      class="field-type-menu"
      label="Field type"
      [selected]="selectedFieldType"
      [menuItems]="availableFormatTypes"
      (menuChange)="fieldTypeChange($event)"
    ></mode-labeled-menu>
    <ng-container [ngSwitch]="selectedFieldType?.value">
      <mode-currency-format-pane
        *ngSwitchCase="Currency"
        [format]="format"
        (formatChange)="paneFormatChange($event)"
      ></mode-currency-format-pane>
      <mode-date-format-pane
        *ngSwitchCase="Date"
        [format]="format"
        (formatChange)="paneFormatChange($event)"
      ></mode-date-format-pane>
      <mode-number-format-pane
        *ngSwitchCase="Number"
        [format]="format"
        (formatChange)="paneFormatChange($event)"
      ></mode-number-format-pane>
      <mode-percent-format-pane
        *ngSwitchCase="Percent"
        [format]="format"
        (formatChange)="paneFormatChange($event)"
      ></mode-percent-format-pane>
      <mode-url-format-pane
        *ngSwitchCase="Url"
        [format]="format"
        [encoding]="encoding"
        (formatChange)="paneFormatChange($event)"
      ></mode-url-format-pane>
      <ng-container *ngSwitchCase="PlainText"><p>Plain text columns have no specific formatting.</p></ng-container>
      <ng-container *ngSwitchDefault><p>Unsupported field type.</p></ng-container>
    </ng-container>
    <div class="example-formatting" *ngIf="selectedFieldType?.value !== PlainText">
      <ng-container *ngIf="isValid; then exampleTemplate; else errorTemplate"></ng-container>
      <ng-template #exampleTemplate>
        <p class="example">
          <span>Example styling:</span>
          <span class="formatted-sample" [innerHTML]="exampleFormatting"></span>
        </p>
      </ng-template>
      <ng-template #errorTemplate>
        <p class="formatter-errors">
          <capra-icon icon="icon-warning" class="status-icon"></capra-icon>
          <span class="error-msg">{{ errorText }}</span>
        </p>
      </ng-template>
    </div>
  </div>
  <div class="action-buttons">
    <div class="left-actions">
      <capra-button
        data-test="text-formatting-modal-cancel-button"
        text="Cancel"
        variant="secondary"
        color="neutral"
        (clicked)="doCancel()"
      ></capra-button>
      <capra-button
        data-test="text-formatting-modal-reset-button"
        text="Reset"
        variant="secondary"
        color="neutral"
        (clicked)="doReset()"
        [disabled]="!hasChanges"
      ></capra-button>
    </div>
    <div class="right-actions">
      <capra-button
        data-test="text-formatting-modal-apply-button"
        text="Apply"
        variant="secondary"
        color="neutral"
        (clicked)="doApply(false)"
        [disabled]="!hasChanges || !isValid"
      ></capra-button>
      <capra-button
        data-test="text-formatting-modal-apply-and-close-button"
        text="Apply & close"
        color="default"
        (clicked)="doApply(true)"
        [disabled]="!isValid"
      ></capra-button>
    </div>
  </div>
</div>
